import { makeSx } from '../../../../../theme/_utils'
import { defaultPalette } from '../../../../../theme/idsTheme'

export default makeSx({
    PatientFormHeaderDialogContent: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '4rem',
    },
    PatientFormHeaderDialogSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        padding: '2.2rem .5rem',
        borderBottom: `1px solid ${defaultPalette.lightGrey.half}`,
        '&:last-of-type': {
            borderBottom: 'none',
        },
    },
    identityDowngradeInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '.5rem',
    },
    identityDowngradeInfoTags: {
        display: 'flex',
        alignItems: 'center',
        gap: '.5rem',
    },
})
